import { View } from 'react-native';
import { Card, Text, useTheme } from '@ui-kitten/components';

import { textCategory } from '../../Components/Reservation/constants';
import themeStyle from '../../Theme/styles';

const ReservationEventDetailsPreviewNote = () => {
  const theme = useTheme();
  return (
    <View style={themeStyle.spacingTopMedium}>
      <Card
        status="warning"
        style={{ backgroundColor: theme['color-warning-100'] }}
      >
        <Text
          category={textCategory.SMALL_BODY}
          status="warning"
          style={themeStyle.textCenter}
        >
          You're viewing a preview of your event. Use this to review details and
          see how it will look once published.
        </Text>
      </Card>
    </View>
  );
};

export default ReservationEventDetailsPreviewNote;
